export default () => ({
	personWithAudit: [],
	oneAudit: null,
});
